const accordions = document.querySelectorAll('.js-accordion');
const OPEN = 'is-open';

for (let i = 0; i < accordions.length; i += 1) {
  accordions[i].addEventListener('click', e => {
    e.preventDefault();
    e.currentTarget.classList.toggle(OPEN);
  });
}
